import {
    type TextStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverSurfaceSearchSizeConstantType,
    PopoverSurfaceSearchDynamicStyleType,
    PopoverSurfaceSearchMeasures,
    PopoverSurfaceSearchKeys,
    PopoverSurfaceSearchSize
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getInputTextStyle
} from "../../../../helpers/theme/input";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

export const POPOVER_SURFACE_SEARCH_SIZES: Record<PopoverSurfaceSearchSize, PopoverSurfaceSearchKeys> = {
    large: {
        paddingHorizontal: "medium",
        variant: "bodyLargeSize",
        buttonSize: "medium",
        iconSize: "large",
        height: "large"
    },
    medium: {
        paddingHorizontal: "small",
        variant: "bodyMediumSize",
        buttonSize: "small",
        iconSize: "medium",
        height: "medium"
    }
};

export const getPopoverSurfaceSearchSize = ({
    controlPaddings,
    controlHeights,
    touchTargets,
    pointerType,
    iconSizes,
    size
}: PopoverSurfaceSearchSizeConstantType): PopoverSurfaceSearchMeasures => {
    const sizeKeys = POPOVER_SURFACE_SEARCH_SIZES[size];

    const hitArea = getHitArea({
        visualSize: controlHeights[sizeKeys.buttonSize],
        touchTargets,
        pointerType
    });

    return {
        actionOffset: (hitArea.minWidth - iconSizes[sizeKeys.buttonSize]) / 2,
        paddingHorizontal: controlPaddings[sizeKeys.paddingHorizontal],
        height: controlHeights[sizeKeys.height],
        iconSize: iconSizes[sizeKeys.iconSize],
        buttonSize: sizeKeys.buttonSize,
        variant: sizeKeys.variant
    };
};

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    icon: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "stretch",
        flexShrink: 0
    }
});

export const useStyles = ({
    currentSize,
    pointerType,
    typography,
    borders,
    colors,
    spaces
}: PopoverSurfaceSearchDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: currentSize.paddingHorizontal,
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.separator,
            marginHorizontal: -spaces.spacingXs,
            marginBottom: spaces.spacingXs,
            marginTop: -spaces.spacingXs,
            height: currentSize.height,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        input: {
            ...getInputTextStyle({
                textStyle: typography[currentSize.variant],
                pointerType,
                typography
            }),
            color: colors.content.text.high
        } as Mutable<TextStyle>,
        action: {
            marginEnd: -currentSize.actionOffset
        } as Mutable<ViewStyle>,
        icon: {
            height: currentSize.iconSize,
            width: currentSize.iconSize
        } as Mutable<ViewStyle>
    };

    delete styles.input.lineHeight;

    return styles;
};
export default stylesheet;
